import { take, put, select, call } from 'redux-saga/effects';

import { HTTP_ERROR_401 } from 'modules/app/constants/actionTypes';
import { login, logout } from '../actions';
import { refreshUser } from '../repository';
import { getJWT } from '../selectors';

export function *refreshOn401() {
    while(true) {
        const {failedAction} = yield take(HTTP_ERROR_401);
        const jwt = yield select(getJWT);

        if (!jwt) {
            yield put(logout());
        } else {
            try {
                const {jwt,sessionData} = yield call(refreshUser(jwt));
                yield put(login.success(jwt, sessionData));
                yield put(failedAction);
            } catch (error) {
                yield put(logout());
            }
        }

    }
}

